import Image from "@/components/AppImage";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";
import Link from "@/components/AppLink";
import earning_illu from "/public/img/earning-illu.png";

const StartEarning = () => {
  return (
    <section className="start-earning">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="main-content">
            <div className="row">
              <div className="col-lg-6 cus-order d-flex align-items-center">
                <div className="img-area text-center">
                  <Image src={earning_illu} alt="image" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="section">
                  <h2 className="title">
                    Smart digest for busy freelancers
                  </h2>
                  <p>
                    Roll hourly pings into a single summary, mute weekends, or
                    escalate only when amounts cross a threshold you define.
                    OracleMarket learns which alerts you actually open.
                  </p>
                  <Link href={getDashboardPathUrl("/login-2")} className="cmn-btn">
                    Fine-tune notifications
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartEarning;
